import React from 'react'
import styled from 'styled-components'
import { inheritPrimaryColor } from '../colors'

const ToolCard = ({ children, imgSrc, title, ...props }) => {
  return (
    <Container target='_blank' {...props}>
      <Image imgSrc={imgSrc} />
      <ContentColumn>
        <Header children={title} />
        <div children={children} />
      </ContentColumn>
    </Container>
  )
}
const Header = styled.h2`
  margin-top: 0px;
`
const Image = styled.div`
  width: 100px;
  height: 100px;
  margin: 10px;
  flex-shrink: 0;
  background-image: url("${p => p.imgSrc}");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`
const Container = styled.a`
  text-decoration: none;
  white-space: wrap;
  color: rgb(120, 120, 120);
  margin: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  border: 1px solid transparent;
  transition: border-color 0.1s;
  border-radius: 3px;
  &:hover {
    border-color: ${inheritPrimaryColor};
  }
`
const ContentColumn = styled.div`
  margin: 10px;
  min-width: 0px;
  flex-basis: 300px;
  flex-shrink: 0px;
  flex-grow: 1;
`

export default ToolCard